<app-side-menu>
  <div class="stock-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-boxes-stacked me-3"></i>
                {{ stockId ? 'Editar Estoque' : 'Novo Estoque' }}
              </h1>
              <p class="page-subtitle">{{ stockId ? 'Atualize as informações do estoque' : 'Cadastre um novo estoque' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="stock-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Identificação -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-3">
                <label for="code" class="form-label">Código *</label>
                <input 
                  type="text" 
                  id="code"
                  class="form-control"
                  formControlName="code"
                  [class.is-invalid]="isFieldInvalid('code')"
                  [class.is-valid]="code?.valid"
                  placeholder="Ex: EST001">
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('code')">
                  {{ getFieldError('code') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="name" class="form-label">Nome *</label>
                <input 
                  type="text" 
                  id="name"
                  class="form-control"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')"
                  [class.is-valid]="name?.valid"
                  placeholder="Nome do estoque">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="type" class="form-label">Tipo *</label>
                <select 
                  id="type"
                  class="form-select"
                  formControlName="type"
                  [class.is-invalid]="isFieldInvalid('type')">
                  <option value="">Selecione...</option>
                  <option *ngFor="let type of stockTypes" [value]="type">{{ type }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('type')">
                  {{ getFieldError('type') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control" 
                  formControlName="description"
                  [class.is-invalid]="isFieldInvalid('description')"
                  rows="3"
                  placeholder="Descrição detalhada do estoque..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="category" class="form-label">Categoria</label>
                <select 
                  id="category"
                  class="form-select"
                  formControlName="category">
                  <option value="">Selecione...</option>
                  <option *ngFor="let category of stockCategories" [value]="category">{{ category }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="status" class="form-label">Status *</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status')">
                  <option *ngFor="let status of statusOptions" [value]="status.name">{{ status.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
                  {{ getFieldError('status') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Localização & Quantidades -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>
              Localização
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-4">
                <label for="warehouseId" class="form-label">Almoxarifado</label>
                <select 
                  id="warehouseId"
                  class="form-select"
                  formControlName="warehouseId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.name }} ({{ warehouse.code }})
                  </option>
                </select>
              </div>
              
              <div class="col-md-4">
                <label for="location" class="form-label">Localização</label>
                <input 
                  type="text" 
                  id="location"
                  class="form-control"
                  formControlName="location"
                  [class.is-invalid]="isFieldInvalid('location')"
                  placeholder="Ex: Prateleira A1, Gaveta 3">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('location')">
                  {{ getFieldError('location') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="unit" class="form-label">Unidade</label>
                <select 
                  id="unit"
                  class="form-select"
                  formControlName="unit">
                  <option *ngFor="let unit of units" [value]="unit">{{ unit }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="department" class="form-label">Departamento</label>
                <select 
                  id="department"
                  class="form-select"
                  formControlName="department">
                  <option value="">Selecione...</option>
                  <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="branch" class="form-label">Filial</label>
                <select 
                  id="branch"
                  class="form-select"
                  formControlName="branch">
                  <option value="">Selecione...</option>
                  <option *ngFor="let branch of branches" [value]="branch">{{ branch }}</option>
                </select>
              </div>
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-cubes me-2"></i>
              Controle de Quantidades
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-3">
                <label for="minimumQuantity" class="form-label">Quantidade Mínima</label>
                <input 
                  type="number" 
                  id="minimumQuantity"
                  class="form-control"
                  formControlName="minimumQuantity"
                  [class.is-invalid]="isFieldInvalid('minimumQuantity')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('minimumQuantity')">
                  {{ getFieldError('minimumQuantity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="maximumQuantity" class="form-label">Quantidade Máxima</label>
                <input 
                  type="number" 
                  id="maximumQuantity"
                  class="form-control"
                  formControlName="maximumQuantity"
                  [class.is-invalid]="isFieldInvalid('maximumQuantity')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('maximumQuantity')">
                  {{ getFieldError('maximumQuantity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="currentQuantity" class="form-label">Quantidade Atual *</label>
                <input 
                  type="number" 
                  id="currentQuantity"
                  class="form-control"
                  formControlName="currentQuantity"
                  [class.is-invalid]="isFieldInvalid('currentQuantity')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('currentQuantity')">
                  {{ getFieldError('currentQuantity') }}
                </div>
              </div>
              
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-user me-2"></i>
              Responsável
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="responsiblePerson" class="form-label">Pessoa Responsável</label>
                <input 
                  type="text" 
                  id="responsiblePerson"
                  class="form-control"
                  formControlName="responsiblePerson"
                  [class.is-invalid]="isFieldInvalid('responsiblePerson')"
                  placeholder="Nome do responsável">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsiblePerson')">
                  {{ getFieldError('responsiblePerson') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="responsibleEmail" class="form-label">Email</label>
                <input 
                  type="email" 
                  id="responsibleEmail"
                  class="form-control"
                  formControlName="responsibleEmail"
                  [class.is-invalid]="isFieldInvalid('responsibleEmail')"
                  placeholder="email@exemplo.com">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('responsibleEmail')">
                  {{ getFieldError('responsibleEmail') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Valores & Configurações -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-dollar-sign me-2"></i>
              Valores Financeiros
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-4">
                <label for="unitCost" class="form-label">Custo Unitário</label>
                <input 
                  type="number" 
                  id="unitCost"
                  class="form-control"
                  formControlName="unitCost"
                  [class.is-invalid]="isFieldInvalid('unitCost')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('unitCost')">
                  {{ getFieldError('unitCost') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="totalValue" class="form-label">Valor Total</label>
                <input 
                  type="number" 
                  id="totalValue"
                  class="form-control"
                  formControlName="totalValue"
                  [class.is-invalid]="isFieldInvalid('totalValue')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('totalValue')">
                  {{ getFieldError('totalValue') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="currencyCode" class="form-label">Moeda</label>
                <select 
                  id="currencyCode"
                  class="form-select"
                  formControlName="currencyCode">
                  <option *ngFor="let currency of currencyCodes" [value]="currency">{{ currency }}</option>
                </select>
              </div>
              
              <div class="col-md-6">
                <label for="lastInventoryDate" class="form-label">Última Inventário</label>
                <input 
                  type="date" 
                  id="lastInventoryDate"
                  class="form-control"
                  formControlName="lastInventoryDate">
              </div>
              
              <div class="col-md-6">
                <label for="nextInventoryDate" class="form-label">Próximo Inventário</label>
                <input 
                  type="date" 
                  id="nextInventoryDate"
                  class="form-control"
                  formControlName="nextInventoryDate">
              </div>
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-cogs me-2"></i>
              Configurações
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isActive"
                    class="form-check-input" 
                    formControlName="isActive">
                  <label for="isActive" class="form-check-label">
                    <strong>Ativo</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="allowsNegativeStock"
                    class="form-check-input" 
                    formControlName="allowsNegativeStock">
                  <label for="allowsNegativeStock" class="form-check-label">
                    <strong>Permitir Estoque Negativo</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="trackBatch"
                    class="form-check-input" 
                    formControlName="trackBatch">
                  <label for="trackBatch" class="form-check-label">
                    <strong>Rastrear Lote</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="trackExpiration"
                    class="form-check-input" 
                    formControlName="trackExpiration">
                  <label for="trackExpiration" class="form-check-label">
                    <strong>Rastrear Validade</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <label for="stockGroup" class="form-label">Grupo de Estoque</label>
                <input 
                  type="text" 
                  id="stockGroup"
                  class="form-control"
                  formControlName="stockGroup"
                  [class.is-invalid]="isFieldInvalid('stockGroup')"
                  placeholder="Nome do grupo">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('stockGroup')">
                  {{ getFieldError('stockGroup') }}
                </div>
              </div>

              <div class="col-12">
                <label for="notes" class="form-label">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  [class.is-invalid]="isFieldInvalid('notes')"
                  rows="4"
                  placeholder="Observações gerais sobre o item..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('notes')">
                  {{ getFieldError('notes') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Botões de Navegação -->
          <div class="form-actions">
            <div class="d-flex justify-content-between">
              <button 
                type="button"
                class="btn btn-outline-danger"
                (click)="cancel()">
                Cancelar
              </button>
              
              <div>
                <button 
                  type="button"
                  class="btn btn-outline-secondary me-2"
                  (click)="prevStep()"
                  [disabled]="currentStep === 1">
                  <i class="fas fa-arrow-left me-2"></i>
                  Anterior
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary me-2"
                  (click)="nextStep()"
                  *ngIf="currentStep < 3">
                  Próximo
                  <i class="fas fa-arrow-right ms-2"></i>
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary"
                  (click)="save()"
                  [disabled]="isSubmitting"
                  *ngIf="currentStep === 3">
                  <i class="fas fa-save me-2" *ngIf="!isSubmitting"></i>
                  <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
                  {{ stockId ? 'Atualizar' : 'Salvar' }} Estoque
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
